module.exports = __webpack_public_path__ + "media/images/excel-32-d6785442339f1fd1085b135f502e10e6.png";